
export default function useSatoshiPrice(satoshiPrice: number, exponent: number): string {
	if (!satoshiPrice) {
		return '0'
	}

	const satoshis = satoshiPrice / 1e8

	return parseFloat((Math.round(satoshis * exponent) / exponent).toString()).toString()
}
